import { useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import IntakeForm from "@/components/IntakeForm";
import Footer from "@/components/Footer";

export default function HomePage() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {!showForm ? (
        <HeroSection onGetStarted={() => setShowForm(true)} />
      ) : (
        <div className="pt-24 pb-16">
          <IntakeForm onBack={() => setShowForm(false)} />
        </div>
      )}
      
      <Footer />
    </div>
  );
}
